'use strict';
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import debounce from 'lodash/debounce';
import { Link } from 'react-router-dom';
import "./fileUpload.css";
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';

class Form extends React.Component {
	constructor(props) {
		super(props);

		this.onChangeEvent = this.onChangeEvent.bind(this);
		this.fileInputHandle = this.fileInputHandle.bind(this);
		this.focusedElement = document.activeElement.id
	}

	componentWillMount() {
		// jQuery('.selectpicker').selectpicker('refresh');
		this.fileInputHandle();
	}

	componentDidUpdate(prevProps, prevState) {
		// jQuery('.selectpicker').selectpicker('refresh');
		this.fileInputHandle();
		this.initializeChoices();
	}

	onChangeEvent = debounce((e) => {
		if (this.props.handleForm !== undefined && this.props.handleForm !== null) {
			this.props.handleForm({ target: e });
		}
	}, 500);
	initializeChoices() {
		const dropdown = document.querySelectorAll('.js-choice');

		dropdown.forEach((selectElement) => {
			// Destroy existing Choices instance if it exists
			if (selectElement.choicesInstance) {
                try {
                    selectElement.choicesInstance.destroy();
                } catch (error) {
                    console.error("Error destroying Choices.js instance.");
                }
            }

			// Initialize Choices.js
			const choicesInstance = new Choices(selectElement, {
				searchEnabled: false,
				removeItemButton: true,
				shouldSort: false,
				classNames: {
					containerInner: 'custom-class-for-container',
					listDropdown: 'custom-class-for-dropdown'
				}
			});

			// Attach the instance to the DOM element for cleanup later
			selectElement.choicesInstance = choicesInstance;
		});
	}
	componentDidMount() {
		// jQuery('.selectpicker').selectpicker('refresh');
		this.fileInputHandle();
		this.initializeChoices();
		let that=this;
		let min = this.props?.label_array?.dashboardEndTime?.min || '';
		let max = this.props?.label_array?.dashboardEndTime?.max || '';
			jQuery('.date_field').datepicker({
				showOtherMonths: true,
				selectOtherMonths: true,
				changeMonth: true,
				changeYear: true,
				language: 'en',
				minDate: min != '' ? new Date(min) : '',
				maxDate: max != '' ? new Date(max) : '',
				onSelect: function (dateText) {
					console.log("Selected date: " + dateText + "; input's current value: " + this.value);
					let e = {
						target: {
							value: dateText,
							name: document.activeElement.name,
						}
					};
					if (that.props.handleForm !== undefined && that.props.handleForm !== null) {
						that.props.handleForm(e);
					}
				}
			});
	}

	fileInputHandle = () => {
		jQuery('.custom-file-input').off('change');
		jQuery('.custom-file-input').on("change", function () {
			var fileName = jQuery(this).val().split("\\").pop();
			jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
		});
	}

	setCustomTextField(Obj) {
		let field_name = `name_${Obj.defaultId}`;
		let className = 'form-control';
		let format = null;
		let key = this.props.formType
			? `${this.props.formType}_${field_name}_${Obj.text_value}`
			: `${field_name}_${Obj.text_value}`;

		if (Obj.type == 'number') {
			Obj.min = Obj.min ? Obj.min.min : 0;
			Obj.max = Obj.max ? Obj.max.max : 0;
		} else if (Obj.type == 'date') {
			className = 'form-control date_field';
			format = { 'data-date-format': 'yyyy-mm-dd' };
		}
		// Below comparison is with null to allow false value to pass through.
		// We arent comparing with undefined as the value is set to null if it doesnt exist
		if (Obj.errorFlag !== null) {
			className += Obj.errorFlag === true ? ' is-invalid' : ' is-valid';
		}
		let inputId = `${Obj.name}_${Obj.defaultId}`
		let focusedVal = this.focusedElement === inputId ? true : null
		let field = Obj.type == 'date' ? (<div className="input-group w-100">
			<input className="form-control date_field w-80p" defaultValue={Obj.
				defaultValue} id={`${field_name}_${Math.floor(Math.random() * 10)}`} name={Obj.name} onChange={this.onChangeEvent} data-date-format="yyyy-mm-dd" />
			<span className="input-group-text bg-white">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					fill="currentColor"
					className="bi bi-calendar"
					viewBox="0 0 16 16"
				>
					<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v1H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM0 14V5h16v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" />
				</svg>
			</span>
		</div>) : (
			<input
				spellCheck="false"
				type={Obj.type}
				className={className}
				defaultValue={Obj.defaultValue && Obj.encodeValueFlag ? encodePassword(Obj.defaultValue) : Obj.defaultValue}
				id={inputId}
				name={Obj.name}
				disabled={Obj.disabledFlag}
				onChange={(e) => this.onChangeEvent(e.target)}
				required={Obj.requiredFlag}
				key={key}
				min={Obj.min ? Obj.min : null}
				max={Obj.max ? Obj.max : null}
				step={Obj.step ? Obj.step : null}
				format
				data-role={Obj.tagsFlag ? "tagsinput" : null}
				autoFocus={focusedVal}
			/>
		);

		return field;
	}

	largeTextField(index, name, text_value, type, form = null, requiredFlag) {
		let field_name = form === null ? `name_${index}` : name;

		let field = (
			<textarea className="form-control" defaultValue={text_value} id={`textarea_${index}`} name={field_name} required={requiredFlag} />
		);

		return field;
	}

	setDropdown(Obj) {
		let options = [];
		Obj.options.map((element, i) => {
			let innerElement = null;

			innerElement = element.style
				? <option disabled={element.disabled} className={`${element.style} mb-0`} value={element.value} key={`${element.value}_${Obj.defaultId}_${i}`}>
					{element.name}
				</option>
				: <option disabled={element.disabled} value={element.value} key={`${element.value}_${Obj.defaultId}_${i}`} id={`${element.id ? element.id : null}`}>
					{element.name}
				</option>;
			options.push(innerElement);
		});
		let dropdown_name = Obj.name;
		if (this.props.handle_form_drop_down && Obj.multiple === false) {
			return (
				<>
					<select
						data-bs-live-search={Obj.searchVisibility ==false  ? "false" : "true"} // Bootstrap 5 uses data-bs for attributes
						className="js-choice  form-control form-select" // Bootstrap 5 class for select
						id={`${Obj.name}_${Obj.defaultId}`}
						value={Obj.defaultValue}
						name={dropdown_name}
						onChange={Obj.changeEvent}
						multiple={Obj.multiple}
						required={Obj.requiredFlag}
						disabled={Obj.disabledFlag}
						data-bs-size="5"
					>
						{options}
					</select>
					{Obj.extraInfo ? <div className='mt-2'><span className="p-2 tx-medium tx-12 tx-sans" style={{ cursor: 'pointer' }} >
						{Obj.extraValue}</span></div> : ''}
				</>
			);
		} else {
			return (
				<>
					<select
						data-bs-live-search={Obj.searchVisibility ? "false" : "true"}
						className="js-choice  form-control form-select"
						id={`${Obj.name}_${Obj.defaultId}`}
						defaultValue={Obj.defaultValue}
						name={dropdown_name}
						onChange={Obj.changeEvent}
						multiple={Obj.multiple}
						required={Obj.requiredFlag}
						disabled={Obj.disabledFlag}
						data-bs-size="5"
						data-bs-actions-box="true"
					>
						{options}
					</select>
					{Obj.extraInfo ? <div className='mt-2'><span className="alert alert-primary p-2 tx-medium tx-12 tx-sans" style={{ cursor: 'pointer' }} >
						<i className="fa fa-info-circle me-2" style={{ fontSize: 12 }}></i>
						{Obj.extraValue}</span></div> : ''}
				</>
			);
		}
	}

	showPassword(e, encodeValue, index) {
		let passwordFieldID = e.target.previousElementSibling
		let fieldType = passwordFieldID.type === 'password' ? 'text' : 'password';
		if (encodeValue) {
			let fieldValue = passwordFieldID.value
			fieldValue = fieldType === 'password' ? encodePassword(fieldValue) : decodePassword(fieldValue);
			document.getElementById(`${passwordFieldID.id}`).value = fieldValue
		}
		passwordFieldID.setAttribute('type', fieldType);
		$(`#${index}_togglePassword`).toggleClass('fa-eye-slash');
	}

	getFormArray(form, headers, conditionalFormattingFlag, that, index, isValue2) {
		headers.map((element, i) => {
			var change_handle = that.props.handle_form_drop_down ? that.props.handle_form_drop_down : null;
			let text_value = element.text_value !== undefined && element.text_value !== null ? element.text_value : '';
			let disabledFlag = (element.disabled !== null && element.disabled !== undefined) ? element.disabled : null;
			let requiredFlag =
				element.requiredFlag !== null && element.requiredFlag !== undefined ? element.requiredFlag : null;
			let errorFlag = element.errorFlag !== null && element.errorFlag !== undefined ? element.errorFlag : null;
			let tagsFlag = element.tagsInputFlag !== null && element.tagsInputFlag !== undefined ? element.tagsInputFlag : null;

			if (['text', 'date', 'email', 'password', 'number', 'time'].includes(element.type)) {
				let min = element.type == 'date' || element.min ? { min: element.min } : null;
				let max = element.type == 'date' || element.max ? { max: element.max } : null;
				let step = element.type == "time" || element.step ? "1" : null;
				form.push(
					<div key={`form_input_${i}`} className={conditionalFormattingFlag ? 'form-group col-md-3' : "form-group"} id={`form_input_${element.name}`} spellCheck="false">
						{element.forgotFlag ? (
							<div className="d-flex justify-content-between align-items-end mg-b-5">
								<label className="mg-b-0-f" htmlFor={`form_data`}>
									{`${element.label}`}
									{element.loadingFlag ? (
										<span className="spinner-border spinner-border-sm mg-l-10" role="status" aria-hidden="true" />
									) : null}
								</label>
								<Link
									to={element.forgotURL}
									className="tx-13"
									tabIndex={element.forgotTabIndex}
								>{`Forgot ${element.label}?`}</Link>
							</div>
						) : (
							this.props?.type == 'customSearch' ? "" : <label htmlFor={`form_data`}>
								{`${element.label}`}
								{element.loadingFlag ? (
									<span className="spinner-border spinner-border-sm mg-l-10" role="status" aria-hidden="true" />
								) : null}
							</label>
						)}
						{that.setCustomTextField({
							defaultId: conditionalFormattingFlag ? `${index}_form_data` : `form_data`,
							name: element.name,
							defaultValue: text_value,
							type: element.type,
							min,
							max,
							step,
							disabledFlag,
							requiredFlag,
							errorFlag,
							tagsFlag,
							encodeValueFlag: element.encodeValue ? element.encodeValue : null
						})}
						{element.type === 'password' && element.eyeIcon && text_value ? <i className="far fa-eye" id={`${i}_togglePassword`} style={{ float: 'right', position: 'relative', bottom: '25px', right: '10px', cursor: 'pointer' }} onClick={(e) => that.showPassword(e, element.encodeValue, i)}></i> : null}
					</div>
				);
			}

			if (element.type == 'text-large') {
				form.push(
					<div key={`form_input_${i}`} className="form-group" id={`form_input_${element.name}`} spellCheck="false">
						<label htmlFor={`form_data`}>{`${element.label}`}</label>
						{that.largeTextField(`form_data`, element.name, text_value, element.type, 1, element.requiredFlag)}
					</div>
				);
			}
			if (element.type == 'dropdown') {
				form.push(
					conditionalFormattingFlag
						? <div key={`col_${i}`} className={isValue2 == 'number' ? 'col-md-3' : "col-md-4"}>
							<div key={`form_input_${i}`} className={`form-group ${this.props.formWidth ? "row" : ''}`} spellCheck="false">
								{element.label && element.label !== undefined ? <label className={this.props.formWidth ? this.props.formWidth.label : `mg-r-10`} htmlFor={`form_data`} style={{ overflowWrap: 'anywhere' }}>{element.label}</label> : null}
								<span className={this.props.formWidth ? this.props.formWidth.field : ''}>
									{that.setDropdown({
										defaultId: conditionalFormattingFlag ? `${index}_form_data` : `form_data`,
										name: element.name,
										options: element.options,
										defaultValue: text_value,
										changeEvent: change_handle,
										multiple: element.multiple,
										disabledFlag,
										requiredFlag,
										searchVisibility: element.searchVisibility
									})}
								</span>
							</div>
						</div>
						: <div className="">
							<div className="mb-2 ">
									<div>
									{element.label && element.label !== undefined ? <label className={this.props.formWidth ? this.props.formWidth.label : `mg-r-10`} htmlFor={`form_data`} style={{ overflowWrap: 'anywhere' }}>{`${element.label}`}</label> : null}
										{that.setDropdown({
											defaultId: `form_data`,
											name: element.name,
											extraInfo: element.extraInfo,
											extraValue: element.extraValue,
											options: element.options,
											defaultValue: text_value,
											changeEvent: change_handle,
											multiple: element.multiple,
											disabledFlag,
											requiredFlag,
											searchVisibility: element.searchVisibility
										})}
									</div>
								</div>
						</div>
				);
			}

			if (element.type == 'file') {
				let id = element.id !== null && element.id !== undefined ? element.id : 'customFile';
				form.push(
					<div key={`form_input_${i}`} className="custom-file" id={`form_input_${element.name}`} spellCheck="false">
						<input type="file" accept=".csv" className="custom-file-input" id={id} required={element.requiredFlag} />
						<label className="custom-file-label" htmlFor={id}>Choose File</label>
						<div className="mg-x-5 mg-y-5">
							<span className=" tx-medium">Note:</span>
							<br />
							<span className=" tx-medium">1.Supported file format is CSV.</span>
							<br />
							<span className=" tx-medium">2.Upload file of size below 100MB only.</span>
						</div>
					</div>
				);
			}

			if (element.type == 'newFile') {
				let id = element.id !== null && element.id !== undefined ? element.id : 'customFile';
				let accept = element.accept !== null && element.accept !== undefined ? element.accept : ".xlsx, .xls, .csv, .txt";
				let span1 = element.span1 !== null && element.span1 !== undefined ? element.span1 : "1. Supported file format is .csv, .xlsx, .txt.";
				let span2 = element.span2 !== null && element.span2 !== undefined ? element.span2 : "2. Upload file of size below 150MB only.";
				form.push(
					<div className="row">
						<div className="col">
							<label>Upload Your File </label>
							<div key={`form_input_${i}`} className="form-group text-center files" id={`form_input_${element.name}`} spellCheck="false">
								<input type="file" accept={accept} className="form-control" id={id} required={element.requiredFlag} onChange={(e) => {
									this.onChangeEvent(e.target)
								}} />
							</div>
							<div className="mg-x-5 mg-y-5">
								<span className=" tx-medium">Note:</span>
								<br />
								<span className=" tx-medium">{span1}</span>
								<br />
								<span className=" tx-medium">{span2}</span>
							</div>
						</div>
					</div>
				);
			}

			if (element.type == 'checkbox') {
				form.push(
					<div key={`form_input_${i}`} className="custom-file" id={`form_input_${element.name}`} spellCheck="false">
						<div className="custom-control custom-checkbox">
							<input type="checkbox" className="custom-control-input" id={`form_input_${element.name}`} />
							<label className="custom-control-label" htmlFor={`form_input_${element.name}`}>
								{element.label}
							</label>
						</div>
					</div>
				);
			}

			if (element.type == 'customSearch') {
				form.push(
					<div className={`input-group me-2 ${this.props.customWidthClass ? this.props.customWidthClass : ''}`} >
						<input
							className="form-control"
							placeholder={element.placeholder}
							id="searchKeyword"
							type="text"
							autoComplete="off"
							aria-label="Search Input"
							onKeyDown={(e) => this.props?.onSearch(e, 'search')}
							style={{ height: '36px', lineHeight: '1.2', borderRightWidth:"1px" }}
						/>

						<div className="input-group-text" style={{ cursor: 'pointer',height:"36px" }} onClick={(e) => this.props?.onSearch(e, 'search')} >
							Go
						</div>

    {/* {!element?.hideRemoveButton && (
        <div className="input-group-text" onClick={(e) => this.props?.onSearch(e, 'remove')} style={{ cursor: 'pointer' }}>
            <i className='fas fa-window-close' id='remove' aria-hidden="true"></i>
        </div>
    )} */}
</div>
				)

			}

			if (element.type == 'color') {
				let colorClassName = conditionalFormattingFlag
					? isValue2 == 'number' || that.props.formattingType == 'comparison' || that.props.formattingType == 'compareMultiple'
						? "form-group col-md-1"
						: "form-group col-md-3"
					: "form-group"
				let colorLabel = isValue2 == 'number' || that.props.formattingType == 'comparison' || that.props.formattingType == 'compareMultiple'
					? 'Color'
					: element.label
				form.push(
					<div key={`form_input_${i}`} className={colorClassName} id={`form_input_${element.name}`}>
						<label htmlFor={`form_input_${element.name}`}>{colorLabel}</label>
						<input type="color" id={conditionalFormattingFlag ? `${element.name}_${index}_form_data` : `${element.name}_form_data`} name={element.name} value={element.text_value} required={element.requiredFlag} onChange={change_handle} />
					</div>
				)
			}

			if (element.type == 'iconButton') {
				let elementId = conditionalFormattingFlag ? `${element.name}_${index}_form_data` : `${element.name}_form_data`
				form.push(
					<div key={`form_input_${i}`} className={conditionalFormattingFlag ? "form-group col-md-2" : "form-group"} id={`form_input_${element.name}`}>
						<label htmlFor={`form_input_${element.name}`}>{`${element.label}`}</label><br />
						<button className="btn" id={elementId} onClick={element.onClick}><i className="fa fa-trash" id={elementId}></i></button>
					</div>
				)
			}
		});
	}

	render() {
		let form = [];
		let that = this;
		let conditionalFormattingFlag = this.props.conditionalFormatting;
		let headers = Object.values(this.props.label_array)

		conditionalFormattingFlag
			? headers.map((innerData, index) => {
				let isValue2 = innerData.value2.type
				that.getFormArray(form, Object.values(innerData), conditionalFormattingFlag, that, index, isValue2)
			})
			: that.getFormArray(form, headers, conditionalFormattingFlag, that)
		return form;
	}
}

export default Form;
